/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type HTMLAttributes, type ReactNode, createContext, useState } from 'react';
import { mergeProps, useHover, useFocusWithin } from 'react-aria';
import { type ContextValue, createLeafComponent, useContextProps } from 'react-aria-components';

export interface ListItemRenderProps {
  isHovered: boolean;
  isFocusWithin: boolean;
}

interface ListItemProps extends Omit<HTMLAttributes<HTMLLIElement>, 'style' | 'className' | 'children'> {
  style?: stylex.StyleXStyles | (stylex.StyleXStyles | false)[];
  children?: ReactNode | ((renderProps: ListItemRenderProps) => ReactNode);
}

const ListItemContext = createContext<ContextValue<ListItemProps, HTMLLIElement>>({});

const ListItem = createLeafComponent('item', (props: ListItemProps, ref: ForwardedRef<HTMLLIElement>) => {
  [props, ref] = useContextProps(props, ref, ListItemContext);

  const { style, children, ...coreProps } = props;

  const { hoverProps, isHovered } = useHover({});
  const [ isFocusWithin, setIsFocusWithin ] = useState(false);
  const { focusWithinProps } = useFocusWithin({ onFocusWithinChange: setIsFocusWithin });

  const renderProps: ListItemRenderProps = { isHovered, isFocusWithin };
  const resolvedChildren = typeof children === 'function' ? children(renderProps) : children;

  return (
    <li
      ref={ref}
      data-hovered={isHovered || undefined}
      data-focus-within={isFocusWithin || undefined}
      {...mergeProps(hoverProps, focusWithinProps, coreProps)}
      {...stylex.props(styles.base, style)}>
      {resolvedChildren}
    </li>
  );
});

const styles = stylex.create({
  base: {
    margin: 0,
    padding: 0,
    display: 'block',
  },
});

export { ListItem, ListItemContext, type ListItemProps };
